import { useMemo } from 'react';
import { Integration } from '../../../../shared/interfaces/integration';
import { PipelineAPI } from '../../../api/PipelineAPI';
import { IntegrationDisplayConfigFactory } from '../../../factories/integrationFactory';
import { PIPELINE_DISPLAY_CONFIGS } from './constants/display-configs';
import { HevoEntityMeta } from '../../../../shared/components/HevoEntityMeta/HevoEntityMeta';
import { ResolvedComponent } from '../../../../routing/ResolvedComponent';
import type { EntityDisplayConfig as EntityDisplayConfigType } from '../../../../shared/interfaces/entity-display-config';
import { EntityDisplayConfig } from '../../../../shared/components/EntityDisplayConfig/EntityDisplayConfig';
import { getPipelineOverviewActionsProps } from './utils/pipelineOverviewActions';

export function PipelineOverviewSetup({ integration }: { integration: Integration }) {
  const displayConfigResolver = async () => {
    return PipelineAPI.getIntegrationDisplayConfig(integration.id).then(res =>
      IntegrationDisplayConfigFactory(res.data)
    );
  };

  return (
    <ResolvedComponent
      Component={PipelineOverview}
      componentProps={{ integration }}
      resolve={{ displayConfig: displayConfigResolver }}
    />
  );
}

function PipelineOverview({
  integration,
  displayConfig
}: {
  integration: Integration;
  displayConfig: {
    sourceDisplayConfig: EntityDisplayConfigType;
    destinationDisplayConfig: EntityDisplayConfigType;
    integrationDisplayConfig: EntityDisplayConfigType;
  };
}) {
  const actionsProps = useMemo(() => {
    return getPipelineOverviewActionsProps(integration);
  }, [integration]);

  return (
    <>
      <HevoEntityMeta
        meta={{
          createdBy: integration.createdBy,
          createdAt: integration.createdAt,
          updatedBy: integration.updatedBy,
          updatedAt: integration.updatedAt
        }}
        className='ml-1 mb-7'
        title='Overview'
      />

      {PIPELINE_DISPLAY_CONFIGS.map(
        ({ key, title, displayConfigKey, getEntityActionsProps }, index) => {
          const actionProps = getEntityActionsProps(actionsProps);

          return (
            <EntityDisplayConfig
              key={key}
              title={title}
              displayConfig={
                displayConfig[
                  displayConfigKey as keyof ReturnType<typeof IntegrationDisplayConfigFactory>
                ]
              }
              className={index !== PIPELINE_DISPLAY_CONFIGS.length - 1 ? 'mb-5' : ''}
              actionsProps={actionProps}
            />
          );
        }
      )}
    </>
  );
}
